import { StyledBracket, StyledPage } from "./HoudiniDemo.styled";

export const HoudiniDemo = () => {
  return (
    <StyledPage>
      <div>
        <StyledBracket />
      </div>
    </StyledPage>
  );
};
